import React from "react";
import { TFuncKey } from "react-i18next";
import { Assignment } from "@material-ui/icons";
import { Area } from "types";
import { isContentOnly } from "utils/appMode";
import HealthForms from "routes/healthForms/HealthForms";

type ContentFeature = {
  area: Area;
  label: TFuncKey;
  Icon: React.ComponentType;
  render: () => React.ReactNode;
};

export const contentFeatures: ContentFeature[] = [
  {
    area: Area.HealthForms,
    label: "views.health_forms",
    Icon: Assignment,
    render: () => <HealthForms />,
  },
];

const contentAreas: string[] = contentFeatures.map(feature => feature.area);

export const navVisible = (area: string) =>
  isContentOnly ? contentAreas.includes(area) : !contentAreas.includes(area);
